import React from 'react';
import { MarketingArticle } from './marketingArticle.jsx';
import heroImage from '../pictures/Use cases for Back-Step chain.avif';
import goodsImage from '../pictures/Luxurious goods.webp';
import hotelImage from '../pictures/Palace Hotel San Francisco.webp';
import aircraftImage from '../pictures/Airplane Maintenence.webp';

export function UseCases() {
  return (
    <MarketingArticle
      title="Where Back-Step Blockchain Fits"
      kicker="Customer use cases"
      description="Back-Step Blockchain is built for proof-heavy industries where customers, auditors, regulators, and partners need to trust the same record."
      path="/overview"
      heroImage={heroImage}
      heroAlt="Back-Step Blockchain use case illustration"
      primaryAction={{ to: '/contact', label: 'Plan a pilot' }}
      secondaryAction={{ to: '/products', label: 'See products' }}
      sections={[
        {
          tag: 'Luxury and products',
          title: 'Give valuable goods a history customers can verify.',
          image: goodsImage,
          imageAlt: 'Luxury goods display',
          paragraphs: [
            'Brands can record origin, serial numbers, warranty events, ownership changes, and service history. The result is a product story that is harder to fake and easier to trust.',
            'Customers get confidence at the point of sale, and manufacturers gain a stronger record when counterfeit goods appear.',
          ],
        },
        {
          tag: 'Travel and identity',
          title: 'Make important checks faster and more credible.',
          image: hotelImage,
          imageAlt: 'Hotel entrance',
          paragraphs: [
            'Identity, reservations, licenses, membership privileges, and travel events can be verified against trusted records instead of repeated manual checks.',
            'For public institutions and hospitality providers, the benefit is speed with a better audit trail.',
          ],
        },
        {
          tag: 'Safety-critical records',
          title: 'Protect records that must be trusted long after they are created.',
          image: aircraftImage,
          imageAlt: 'Aircraft maintenance',
          paragraphs: [
            'Maintenance logs, training records, inspections, black-box events, and compliance evidence are valuable only if people believe they have not been rewritten.',
            'Back-Step Blockchain gives those records a permanent anchor without forcing every workflow into a public cryptocurrency model.',
          ],
        },
      ]}
    />
  );
}
